import { logger } from "./app.logger";
import { isDefined, notDefined, isNull, notNull } from "./var.check";

if (isDefined(window)) {
  window.logger = logger;
  window.isDefined = isDefined;
  window.notDefined = notDefined;
  window.isNull = isNull;
  window.notNull = notNull;
}
